import Api from '../../../helpers/Api';

// ACTION  TYPE
export const DATA_SINGLE_ARTIST = 'DATA_SINGLE_ARTIST';
const setDataSingleArtist = (dataArtistSingle = '', slug = null) => ({
    type: DATA_SINGLE_ARTIST,
    dataArtistSingle,
    slug,
});

export const SET_CURRENT_SLUG = 'SET_CURRENT_SLUG';
const setCurrentSlug = (slug = null) => ({
    type: SET_CURRENT_SLUG,
    slug,
});

export const SET_NEWS_SINGLE_ARTIST = 'SET_NEWS_SINGLE_ARTIST';
const setNews = (news) => ({
    type: SET_NEWS_SINGLE_ARTIST,
    news,
});

export const SET_IS_RELATED_NEWS = 'SET_IS_RELATED_NEWS';
const setIsRelatedNews = (isRelatedNews) => ({
    type: SET_IS_RELATED_NEWS,
    isRelatedNews,
});

export const SET_NOT_FOUND = 'SET_NOT_FOUND';
export const setNotFound = (notFound) => ({
    type: SET_NOT_FOUND,
    notFound,
});

export const IS_FETCHING_ARTIST_SINGLE = 'IS_FETCHING_ARTIST_SINGLE';
const isFetching = (data) => ({
    type: IS_FETCHING_ARTIST_SINGLE,
    data,
});
// ACTION


export const fetchLatestNews = (limitNews = 6) => (dispatch) => Api.progressGet(dispatch, `/api/v1/news/getNews/0/${limitNews}/false/false`).then((json) => {
    if (json.status === 'success') {
        const myPromise = [
            dispatch(setIsRelatedNews(false)),
            dispatch(setNews(json.data)),
        ];

        return Promise.all(myPromise);
    }

    throw `error from server: ${json.message}`;
}).catch((error) => {
    // eslint-disable-next-line no-console
    console.log('fetchLatestNews got error: ', error);
});

export const fetchRelatedNews = (limitNews = 6, tags) => (dispatch) => Api.progressGet(dispatch, `/api/v1/news/getRelatedNews/${limitNews}/${tags}`).then((json) => {
    if (json.status === 'success') {
        // if don't got at least 6  related news,  get of latest news
        if (json.data.length >= 6) {
            const myPromise = [
                dispatch(setNews(json.data)),
                dispatch(setIsRelatedNews(true)),
            ];

            return Promise.all(myPromise);
        }

        return dispatch(fetchLatestNews(limitNews));
    }

    // if have problem with related news or return 0 news, get latestnews
    return dispatch(fetchLatestNews(limitNews));
}).catch((error) => {
    // eslint-disable-next-line no-console
    console.log('fetchRelatedNews got error: ', error);
});

export const getSingleArtist = (slug) => (dispatch) => {
    dispatch(setNews([]));

    dispatch(isFetching(true));

    return Api.progressGet(dispatch, `api/v1/getSingleArtist/${slug}`)
        .then((json) => {
            const myPromises = [dispatch(setCurrentSlug(slug))];

            if (json.status === 'success') {
                const creatingTags = [];

                creatingTags.push(json.data.artistName);

                creatingTags.push(json.data.artistName.replace(/\s/g, '').toLowerCase());

                const artistTags = encodeURIComponent(creatingTags.join('_'));

                myPromises.push(dispatch(fetchRelatedNews(10, artistTags)));

                myPromises.push(dispatch(setDataSingleArtist(json.data, slug))); // note we set isFetching to false here, too.

                return Promise.all(myPromises);
            }

            if (json.status === 404) {
                // not found
                myPromises.push(dispatch(setNotFound(true)));

                return Promise.all(myPromises);
            }

            throw `error from server: ${json.message}`;
        }).catch((error) => {
            // eslint-disable-next-line no-console
            console.log('getSingleArtist got error:', error);
        });
};

export const getSingleArtistIfNeeded = (slug) => (dispatch, getState) => {
    const currentSlug = getState().artists.ArtistSingle.currentSlug;

    if (currentSlug !== slug) {
        return dispatch(getSingleArtist(slug));
    }

    return Promise.resolve(1);
};
